module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-test-c0792cbb5580b2e975bea71f11b0663f.png";